import { useMapViewport } from '../../hooks/useMapViewport';
import { useStudentClusters } from '../../hooks/useStudentClusters';
import { type ClusterData } from '../../api/studentNetworkV2Api.types';
import { ClusterOverlay } from './StudentCluster';

type MapOverlaysProps = {
    onClusterClick?: (cluster: ClusterData) => void;
    visible?: boolean;
    selectedClusterLatLng?: { lat: number; lng: number } | null;
};

export function MapOverlays({ onClusterClick, visible = true, selectedClusterLatLng }: MapOverlaysProps) {
    const viewport = useMapViewport();
    const { clusters } = useStudentClusters(viewport);

    return (
        <ClusterOverlay
            clusters={clusters}
            onClick={onClusterClick}
            visible={visible}
            selectedClusterLatLng={selectedClusterLatLng}
        />
    );
}
